import LazyLoad from 'vanilla-lazyload';
window.LazyLoad = LazyLoad;
window.lazyLoadInstance = new LazyLoad({});
